module.exports = __webpack_public_path__ + "img/icon-2.320e1b4b.png";